module.exports = __webpack_public_path__ + "static/media/benefits2.d6eacef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/benefits2.png
// module id = 1210
// module chunks = 0